var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg002Videoanlage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451.667,
    height: 451.667,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 453.667,
    width: 453.667,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#f2f2f2",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 224.459,
    cy: 225.795,
    id: "svg_5",
    rx: 213.741,
    ry: 213.823
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 28.646,
    rx: 27.69,
    id: "svg_1",
    cy: 281.503,
    cx: 314.901,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0.8824723194840057,0.015738992697756225,-0.015403611633948091,0.9016862877612569,5.505974860900721,37.07601140718174)",
    id: "svg_2",
    height: 36.112,
    width: 84.925,
    y: 236.066,
    x: 385.25,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0.764359862519048,-0.4509118199348449,0.4413033723831176,0.7810021818605005,-94.34634238657969,188.27799644605068)",
    id: "svg_3",
    height: 100.232,
    width: 297.956,
    y: 143.216,
    x: 146.347,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0.7719452526267002,-0.4372127763743938,0.4278962407569743,0.7887527277942121,-57.612117770786604,179.77929299025078)",
    id: "svg_4",
    height: 141.746,
    width: 270.722,
    y: 43.622,
    x: 171.829,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0.7719452526267002,-0.4372127763743938,0.4278962407569743,0.7887527277942121,-82.95955858799242,119.83075895398042)",
    id: "svg_6",
    height: 42.192,
    width: 199.426,
    y: 115.685,
    x: 64.598,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-0.41435876779077213,-0.7962630120062187,0.779295500732401,-0.4233805535668835,-161.4499053117012,558.8768494113272)",
    id: "svg_7",
    height: 25.792,
    width: 64.999,
    y: 374.397,
    x: 135.567,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f03",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-0.8633196697845675,-0.1874996777847333,0.18350426063150654,-0.8821166296235649,167.1495718077597,545.3401732974229)",
    id: "svg_8",
    height: 70.051,
    width: 148.207,
    y: 330.513,
    x: 70.52,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 17.329,
    rx: 15.922,
    id: "svg_9",
    cy: 232.176,
    cx: 289.98,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_10",
    d: "m443.07038,193.70651l-13.17732,0c-12.13231,0 -22.0025,10.0851 -22.0025,22.48156l0,32.91296l-59.15937,0c-6.62484,-8.86312 -16.563,-15.00003 -27.90891,-16.47451l-12.40768,-21.95851l51.06145,-30.12181c4.2215,-2.48994 5.6681,-8.00549 3.23034,-12.31891l-12.05641,-21.33805l20.88336,-12.31981c4.22151,-2.48994 5.6681,-8.00549 3.23034,-12.31891l-49.41097,-87.44714c-7.42714,-13.14318 -21.32467,-21.30829 -36.26985,-21.30829c-7.28768,0 -14.47475,1.96778 -20.7845,5.68961l-263.88353,155.67009c-4.22151,2.48993 -5.6681,8.00549 -3.23034,12.31891l16.46944,29.14784c1.17034,2.07149 3.09795,3.58295 5.35919,4.2016l24.41996,6.68612l-10.0776,5.94392c-2.02735,1.19582 -3.5066,3.1654 -4.11207,5.47587c-0.60635,2.31047 -0.28861,4.77245 0.88172,6.84304l32.93889,58.29298c1.63547,2.89305 4.60103,4.51092 7.6522,4.51092c1.4969,0 3.01498,-0.38959 4.40421,-1.20935l20.886,-12.32161l12.05817,21.34075c1.17034,2.07149 3.09795,3.58295 5.35919,4.2016c0.75198,0.20562 1.51897,0.30752 2.28419,0.30752c1.53573,0 3.06,-0.41033 4.41303,-1.20844l140.47746,-82.87128l12.40327,21.94948c-2.08736,5.07366 -3.24358,10.64152 -3.24358,16.48173c0,23.53219 18.73686,42.6761 41.76672,42.6761c13.52771,0 25.56735,-6.61037 33.20543,-16.82983l59.15936,0l0,32.91295c0,12.39557 9.87019,22.48066 22.00251,22.48066l13.17732,0c4.87463,0 8.82606,-4.03746 8.82606,-9.01823l0,-144.44329c0.00089,-4.98077 -3.95143,-9.01824 -8.82518,-9.01824zm-411.95758,10.36196l-10.22853,-18.10321l256.24015,-151.16098c3.62928,-2.14093 7.76518,-3.27271 11.95844,-3.27271c8.65838,0 16.69892,4.70932 20.98221,12.29005l44.99794,79.63734l-196.01813,115.63453l-127.93208,-35.02502zm46.82582,82.86857l-24.11282,-42.67249l13.24352,-7.8125l24.11193,42.67249l-13.24263,7.8125zm45.00058,12.32071l-34.34046,-60.7775c-0.00088,-0.0009 0,0 -0.00088,-0.0009l69.41084,19.00323c0.33892,0.09289 0.68049,0.15692 1.02382,0.20742c0.10239,0.01533 0.20477,0.02435 0.30803,0.03607c0.25331,0.02796 0.50574,0.04509 0.75993,0.0505c0.06355,0.0009 0.12798,0.01263 0.19241,0.01263c0.03971,0 0.07855,-0.00722 0.11826,-0.00812c0.33893,-0.00451 0.67608,-0.02344 1.01147,-0.06763c0.00706,-0.00091 0.01412,-0.00091 0.0203,-0.00181c0.34157,-0.04599 0.67961,-0.11814 1.01323,-0.20561c0.09797,-0.02526 0.19506,-0.05592 0.29215,-0.08478c0.24713,-0.07304 0.49073,-0.15691 0.7308,-0.25251c0.09532,-0.03787 0.19152,-0.07304 0.28508,-0.11453c0.32038,-0.14068 0.63636,-0.29399 0.94086,-0.47346l170.65731,-100.67508l7.64337,13.52826l-220.06652,129.82382zm156.94778,-71.75991l13.24087,-7.81159l8.49068,15.02618c-4.89229,1.77118 -9.36358,4.4487 -13.22851,7.83234l-8.50304,-15.04693zm59.70394,48.95099c-0.00707,0.11814 -0.01766,0.23538 -0.0256,0.35261c-0.02913,0.39049 -0.0662,0.78098 -0.11297,1.16877c-0.01501,0.12174 -0.02913,0.24349 -0.0459,0.36433c-0.05914,0.44009 -0.12886,0.87838 -0.21183,1.31396c-0.00971,0.0496 -0.01677,0.0992 -0.02559,0.1488c-0.09444,0.48518 -0.20565,0.96585 -0.32921,1.44382c-0.03001,0.11904 -0.0662,0.23718 -0.09797,0.35622c-0.09268,0.33548 -0.19153,0.67006 -0.29744,1.00193c-0.05737,0.18217 -0.11827,0.36343 -0.18005,0.5438c-0.09003,0.26062 -0.18623,0.51674 -0.2842,0.77376c-0.07944,0.20472 -0.15358,0.41123 -0.23654,0.61234c-0.03177,0.07846 -0.06973,0.15421 -0.10238,0.23177c-0.2436,0.57085 -0.5075,1.12998 -0.79082,1.67739c-0.06531,0.12626 -0.13062,0.25251 -0.19859,0.37787c-4.11118,7.60598 -12.03875,12.77072 -21.12607,12.77072c-13.29647,0 -24.11458,-11.05365 -24.11458,-24.63962s10.81811,-24.63963 24.11458,-24.63963c9.08555,0 17.01136,5.16294 21.12254,12.76622c0.06973,0.12896 0.13681,0.25972 0.20389,0.39049c0.13857,0.26784 0.27714,0.53568 0.406,0.80893c0.16946,0.36163 0.33362,0.72597 0.48543,1.09572c0.08296,0.1984 0.15622,0.40131 0.23301,0.60242c0.09973,0.26062 0.19858,0.52125 0.28861,0.78458c0.0609,0.17856 0.12092,0.35803 0.17829,0.53839c0.10679,0.33458 0.20653,0.67096 0.2992,1.01004c0.03177,0.11634 0.06708,0.23177 0.09709,0.34901c0.12356,0.47887 0.23477,0.96044 0.32921,1.44652c0.00971,0.0478 0.01677,0.0965 0.0256,0.1443c0.08296,0.43648 0.15269,0.87657 0.21182,1.31756c0.01677,0.11994 0.03089,0.24169 0.0459,0.36253c0.04678,0.38869 0.08385,0.77828 0.11297,1.16967c0.00883,0.11724 0.01854,0.23357 0.0256,0.35171c0.03001,0.49961 0.04854,0.99922 0.04854,1.50154s-0.01853,1.00192 -0.04854,1.50153zm68.29964,6.30916l-51.30329,0l0,-0.0009c0.03001,-0.16864 0.05208,-0.33819 0.08032,-0.50683c0.06796,-0.40221 0.13504,-0.80443 0.19241,-1.21025c0.03972,-0.28046 0.07149,-0.56183 0.10503,-0.8423c0.04678,-0.38778 0.09532,-0.77557 0.13151,-1.16696c0.03177,-0.33908 0.05295,-0.67997 0.0759,-1.02086c0.02383,-0.33728 0.05384,-0.67186 0.06884,-1.01095c0.0256,-0.55642 0.03619,-1.11375 0.04149,-1.67198c0.00088,-0.12715 0.00971,-0.25251 0.00971,-0.38057c0,-0.12806 -0.00883,-0.25341 -0.00971,-0.38057c-0.0053,-0.55823 -0.01501,-1.11555 -0.04149,-1.67198c-0.01588,-0.33908 -0.04501,-0.67456 -0.06884,-1.01184c-0.02383,-0.33999 -0.04413,-0.67998 -0.0759,-1.01907c-0.03619,-0.39229 -0.08562,-0.78007 -0.13151,-1.16876c-0.03442,-0.27956 -0.06531,-0.56003 -0.10503,-0.83869c-0.05649,-0.40763 -0.12445,-0.81165 -0.19241,-1.21476c-0.02824,-0.16774 -0.05031,-0.33638 -0.08032,-0.50322l51.30329,0l0,15.62049zm26.35375,55.39271l-4.35125,0c-2.35832,0 -4.35037,-2.03451 -4.35037,-4.44419l0,-117.51934c0,-2.40967 1.99204,-4.44509 4.35037,-4.44509l4.35125,0l0,126.40862z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e8ee",
    id: "svg_11",
    d: "m236.94287,118.91467c-2.43599,-4.31342 -7.83402,-5.79422 -12.05553,-3.30338l-0.19593,0.11543c-4.22151,2.48904 -5.66987,8.00459 -3.23299,12.31801c1.63458,2.89395 4.60191,4.51183 7.65308,4.51183c1.49602,0 3.01322,-0.38959 4.40244,-1.20845l0.19594,-0.11543c4.22151,-2.48903 5.66987,-8.00459 3.23299,-12.31801z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e8ee",
    id: "svg_12",
    d: "m296.82156,83.58392c-2.43688,-4.31252 -7.83225,-5.79151 -12.05641,-3.30067l-36.40311,21.47513c-4.22151,2.48993 -5.6681,8.00548 -3.23034,12.31891c1.63547,2.89215 4.60102,4.51002 7.6522,4.51002c1.4969,0 3.0141,-0.38959 4.4042,-1.20935l36.40312,-21.47513c4.22151,-2.48993 5.6681,-8.00548 3.23034,-12.31891z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e8ee",
    id: "svg_13",
    d: "m313.68376,113.42527c-2.43599,-4.31432 -7.83313,-5.79422 -12.05552,-3.30338l-0.19594,0.11543c-4.22151,2.48903 -5.66987,8.00459 -3.23299,12.31801c1.63459,2.89485 4.60191,4.51182 7.65308,4.51182c1.49602,0 3.01322,-0.38958 4.40244,-1.20844l0.19594,-0.11543c4.22151,-2.48904 5.66987,-8.00459 3.23299,-12.31801z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3e8ee",
    id: "svg_14",
    d: "m290.00695,127.3873c-2.43776,-4.31252 -7.83401,-5.79151 -12.0564,-3.30067l-36.40224,21.47512c-4.22239,2.48994 -5.6681,8.00459 -3.23034,12.31801c1.63547,2.89396 4.60103,4.51092 7.6522,4.51092c1.4969,0 3.01499,-0.38958 4.40421,-1.20934l36.40223,-21.47513c4.22151,-2.49083 5.6681,-8.00549 3.23034,-12.31891z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0.8824723194840057,0.015738992697756225,-0.015403611633948091,0.9016862877612569,5.5583575300698005,36.16968438239553)",
    id: "svg_15",
    height: 146.602,
    width: 16.208,
    y: 183.72,
    x: 477.219,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#193351",
    stroke: "null"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg002Videoanlage);
export default __webpack_public_path__ + "static/media/002 Videoanlage.8e88b2b90ed42b0530b454aec515df42.svg";
export { ForwardRef as ReactComponent };